const handlers = {};

const aliases = {};

let observer;


export function init () {
  for (const handler of Object.values(handlers)) {
    document.querySelectorAll(handler.selector).forEach(el => {
      onInserted(el, handler);
    });
  }

  observer = new MutationObserver(function(mutationList) {
    for (var mutation of mutationList) {
      for (var child of mutation.addedNodes) {
        if (! (child instanceof Element)) {
          continue;
        }
        for (const handler of Object.values(handlers)) {
          if (child.matches(handler.selector)) {
            onInserted(child, handler);
          } else {
            child.querySelectorAll(handler.selector).forEach(el => {
              onInserted(el, handler);
            });
          }
        }
      }
    }
  });

  observer.observe(document.body, {childList: true, subtree: true});
}

function isGmfControlled(el) {
  while(el && el.tagName) {
      if(el.getAttribute('data-gmf') !== null) return true;
      // apply old-browser compatibility as needed

      el = el.parentNode;
  }
  return false;
}

function onInserted (el, handler) {
  if (isGmfControlled(el)) {
    return;
  }
  el.setAttribute('data-gmf', '');
  el.classList.add('gmf-context');

  // Alias handling
  if (handler.selector in aliases) {
    if (! handlers[aliases[handler.selector]]) {
      console.error('Invalid alias ' + handler.selector + ' widget ' + aliases[handler.selector] + ' does not exist');
      handler.handle(el); // original handler
      return;
    }

    if (handler.selector[0] === '.') {
      el.classList.remove(handler.selector.slice(1));
    } else if (handler.selector[0] === '#') {
      el.removeAttribute('id');
    }

    handler = handlers[aliases[handler.selector]];

    if (handler.selector[0] === '.') {
      el.classList.add(handler.selector.slice(1));
    } else if (handler.selector[0] === '#') {
      el.id = handler.selector.slice(1);
    }
  }
  handler.handle(el);
}

export function elAttach (selector, callback) {
  const handler = {
    selector,
    handle: callback,
  };
  handlers[selector] = handler;

  if (observer) {
    setTimeout(() => {
      document.querySelectorAll(selector).forEach(el => {
        onInserted(el, handler);
      });
    }, 0);
  }
}

export function alias (originalSelector, newSelector) {
  aliases[originalSelector] = newSelector;
}
